import { createContext, useCallback, useContext, useRef, useState } from "react";
import CelebrationBurst from "../components/shared/CelebrationBurst";
import InfoModal from "../components/Modals/InfoModal";

const CelebrationContext = createContext({
    celebrate: () => false,
    showCompletionMessage: () => false,
});

export const CelebrationProvider = ({ children }) => {
    const [celebrationActive, setCelebrationActive] = useState(false);
    const [completionMessages, setCompletionMessages] = useState([]);
    const celebrationActiveRef = useRef(false);
    const nextCompletionMessageIdRef = useRef(1);
    const lastCompletionMessageRef = useRef(null);

    const celebrate = useCallback(() => {
        if (celebrationActiveRef.current) return false;

        celebrationActiveRef.current = true;
        setCelebrationActive(true);
        return true;
    }, []);

    const handleCelebrationComplete = useCallback(() => {
        celebrationActiveRef.current = false;
        setCelebrationActive(false);
    }, []);

    const showCompletionMessage = useCallback((message) => {
        if (!message) return false;

        const completionMessage = {
            id: nextCompletionMessageIdRef.current,
            message,
        };
        nextCompletionMessageIdRef.current += 1;
        setCompletionMessages((messages) => [...messages, completionMessage]);
        return true;
    }, []);

    const closeCompletionMessage = useCallback((messageId) => {
        setCompletionMessages((messages) =>
            messages[0]?.id === messageId ? messages.slice(1) : messages,
        );
    }, []);

    const currentCompletionMessage = completionMessages[0];
    if (currentCompletionMessage?.message) {
        lastCompletionMessageRef.current = currentCompletionMessage.message;
    }

    return (
        <CelebrationContext.Provider value={{ celebrate, showCompletionMessage }}>
            {children}
            <CelebrationBurst
                active={celebrationActive}
                onComplete={handleCelebrationComplete}
            />
            <InfoModal
                infoModal={completionMessages.length > 0}
                title={null}
                message={
                    currentCompletionMessage?.message ??
                    lastCompletionMessageRef.current
                }
                buttonText="Let's go!"
                onClose={() =>
                    closeCompletionMessage(currentCompletionMessage?.id)
                }
                dialogClassName="z-[310]"
            />
        </CelebrationContext.Provider>
    );
};

export const useCelebration = () => useContext(CelebrationContext);
